import api from "../../services/api";
import { useCallback } from "react";

let _queuesCache = {
  data: null,
  ts: 0,
  promise: null,
};
const TTL_MS = 60 * 1000; // 1 min

const useQueues = () => {
  const findAll = useCallback(async ({ forceRefresh = false } = {}) => {
    const now = Date.now();
    if (!forceRefresh && _queuesCache.data && now - _queuesCache.ts < TTL_MS) {
      return _queuesCache.data;
    }
    if (!forceRefresh && _queuesCache.promise) {
      return _queuesCache.promise;
    }
    _queuesCache.promise = api
      .get("/queue")
      .then(({ data }) => {
        _queuesCache.data = data;
        _queuesCache.ts = Date.now();
        return data;
      })
      .finally(() => {
        _queuesCache.promise = null;
      });
    return _queuesCache.promise;
  }, []);

  return { findAll };
};

export default useQueues;
